import { MessageCircle } from "lucide-react";

export default function WhatsAppFloat() {
  return (
    <a
      href="https://wa.me/573185329505?text=Hola%2C%20quiero%20m%C3%A1s%20informaci%C3%B3n%20sobre%20el%20programa%20de%20ingl%C3%A9s"
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Chatea con nosotros por WhatsApp"
      data-testid="whatsapp-float-button"
      className="fixed bottom-6 right-6 z-50 w-14 h-14 rounded-full bg-emerald-500 text-white flex items-center justify-center shadow-lg shadow-emerald-900/30 hover:bg-emerald-600 hover:scale-105 transition-all"
    >
      <MessageCircle className="w-7 h-7" />
    </a>
  );
}
